<template>
  <div class="view-balance">
    <div class="d-flex justify-content-between mb-6">
      <h4 class="text-semibold">Saldo</h4>
      <snow-button
        :disabled="!canWithdraw"
        text="Sacar"
        @click="modal = true"
      />
    </div>
    <div>
      <action-dispatcher
        action="financial/getBalance"
        v-if="$permissions.hasPermission('efetuar-saque')"
      >
        <template v-if="_balance">
          <div class="row">
            <div class="col-lg-6 mb-5">
              <info-card
                title="Saldo"
                icon="ph ph-currency-circle-dollar"
                :value="getFuture(_balance)"
              />
            </div>
            <div class="col-lg-6 mb-5">
              <info-card
                title="Disponível para saque"
                icon="ph ph-shield-check"
                :value="getBalance(_balance)"
              />
            </div>
          </div>
          <responsive-modal
            size="lg"
            v-model="modal"
            title="Saque"
            description="Selecione sua conta bancária e o valor a sacar desejado"
          >
            <withdraw-modal :balance="_balance" @close="modal = false" />
          </responsive-modal>
        </template>
      </action-dispatcher>

      <b-tabs
        content-class="mt-5"
        v-if="$permissions.hasPermission('ver-extrato')"
      >
        <b-tab title="Extrato" active>
          <transactions :show-values="showValues" />
        </b-tab>

        <b-tab title="Histórico de Saques">
          <withdraws :show-values="showValues" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Transactions from "@/components/balance/Transactions.vue";
import WithdrawModal from "@/components/balance/WithdrawModal.vue";
import Withdraws from "@/components/balance/Withdraws.vue";
import InfoCard from "@/components/InfoCard.vue";

import { formatMoney } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  components: {
    Transactions,
    Withdraws,
    WithdrawModal,
    InfoCard
  },
  data() {
    return {
      showValues: true,
      exportLoading: false,
      modal: false
    };
  },
  computed: {
    ...mapState("financial", ["balance"]),
    _balance() {
      return this.balance.length ? this.balance[0] : null;
    },
    canWithdraw() {
      return (
        this.$permissions.hasPermission("efetuar-saque") &&
        this._balance &&
        this._balance.amount > 0
      );
    }
  },
  mounted() {
    this.$store.dispatch("financial/getBankAccounts");
    this.$store.dispatch("financial/getBanksList");
    this.$store.dispatch("user/getInfo");
  },
  methods: {
    getFuture(item) {
      return formatMoney(item.future?.total);
    },
    getBalance(item) {
      return formatMoney(item.amount);
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .text-warning {
    color: #974600e0 !important;
  }
  .text-success {
    color: #006b20e0 !important;
  }
  .text-danger {
    color: #d0000ee0 !important;
  }
  .nav-tabs {
    border-bottom: 0;
  }
  .nav-link {
    padding: 12px;
  }

  .nav-item {
    @media screen and (max-width: 991px) {
      flex: 1 1 auto;
      text-align: center;
    }
  }
  .fw-500 {
    font-weight: 500;
  }
  .blur {
    .amount {
      filter: blur(8px);
    }
  }
}
</style>
